<template>
  <div>
    <div class="info">
      <h1>{{ $t('payroll_wage_19') }}</h1>
      <p>
        <!-- 记薪月份 -->
        <span>
          <label>{{ $t('398') }}：</label>
          {{ activeData.info.pay_month }}
        </span>
        <!-- 薪资周期 -->
        <span>
          <label>{{ $t('wage.1') }}：</label>
          {{ activeData.info.start_date }}
          {{ $t('409') }}
          {{ activeData.info.end_date }}
        </span>
        <!-- 考勤周期 -->
        <span>
          <label>{{ $t('wage.2') }}：</label>
          {{ activeData.info.att_start_date }}
          {{ $t('409') }}
          {{ activeData.info.att_end_date }}
        </span>
      </p>
    </div>
    <div class="content">
      <h1>{{ $t('payroll_wage_20') }}</h1>
      <div class="search">
        <div class="search-left">
          <!--筛选 -->
          <el-button class="screen" size="small" @click="handleSearch">
            {{ $t('415') }}
          </el-button>
          <el-input
            class="search-input"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="form.search_word"
          >
          </el-input>
          <el-button size="small" type="primary" @click="loadSubStaffList()">{{ $t('69') }}</el-button>
        </div>
        <div class="search-center"></div>
        <div class="search-right">
          <!-- 批量删除 -->
          <el-button
            :loading="deleteLoa"
            size="small"
            @click="batchDelete(false)"
            type="danger"
            plain
            :disabled="!multipleSelection.length"
            >{{ $t('payroll_wage_21') }}</el-button
          >
          <!-- 更新数据 -->
          <el-tooltip class="item" effect="dark" :content="$t('payroll_salary_34')" placement="top-start">
            <el-button :disabled="!subStaffList.length" size="small" :loading="updateLoa" @click="updateData">{{
              $t('payroll_wage_22')
            }}</el-button>
          </el-tooltip>
          <!-- 批量添加成员 -->
          <el-button size="small" @click="batchAddStaff">{{ $t('payroll_wage_23') }}</el-button>
          <!--添加成员 -->
          <el-button size="small" @click="addStaff" type="primary">{{ $t('12') }}</el-button>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        :data="subStaffList"
        :row-key="row => row.id"
        :max-height="tableHeight"
        @sort-change="handlerSort"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :reserve-selection="true" width="65"></el-table-column>
        <!-- 姓名 -->
        <el-table-column
          :label="$t('22')"
          prop="staff_name"
          min-width="264px"
          sortable="custom"
          fixed="left"
        ></el-table-column>
        <!-- 工号 -->
        <el-table-column :label="$t('25')" prop="staff_code" min-width="160px" sortable="custom"></el-table-column>
        <!-- 手机号 -->
        <el-table-column :label="$t('825')" prop="staff_phone" min-width="168px"></el-table-column>
        <!-- 部门 -->
        <el-table-column :label="$t('27')" prop="department_name" min-width="240px"></el-table-column>
        <!-- 职位 -->
        <el-table-column :label="$t('24')" prop="job_title" min-width="168px"></el-table-column>
        <!-- 社保 -->
        <el-table-column :label="$t('420')" prop="social_security_status_text" min-width="168px"></el-table-column>
        <!-- 税 -->
        <el-table-column :label="$t('421')" prop="tax_deduction_status_text" min-width="192px"></el-table-column>
        <!-- 公积金 -->
        <el-table-column :label="$t('1490')" prop="provident_fund_status_text" min-width="192px"></el-table-column>
        <!-- 银行 -->
        <el-table-column :label="$t('417')" prop="bank_name" min-width="168px"></el-table-column>
        <!-- 银行卡号 -->
        <el-table-column :label="$t('418')" prop="bank_card_no" min-width="168px"></el-table-column>
        <!-- 员工属性 -->
        <el-table-column :label="$t('32')" prop="staff_formal_text" min-width="216px"></el-table-column>
        <!-- 在职状态 -->
        <el-table-column :label="$t('state')" prop="staff_state_text" min-width="168px"></el-table-column>
        <!-- 入职时间 -->
        <el-table-column :label="$t('28')" prop="hire_date" min-width="192px"></el-table-column>
        <!-- 离职时间 -->
        <el-table-column :label="$t('29')" prop="leave_date" min-width="192px"></el-table-column>
        <!-- 操作 -->
        <el-table-column :label="$t('70')" align="center" min-width="192px" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" circle @click="handleCheck(row)">{{ $t('from_info') }}</el-button>
            <el-button type="text" circle @click="batchDelete(row)">{{ $t('65') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.page"
      :page-sizes="page.pageSizes"
      :page-size="form.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    />
    <!-- 信息筛选 -->
    <search-popup ref="searchPopup" @submit="getSearchData"></search-popup>
    <!-- 人员选择 -->
    <organization
      v-if="orgVisible"
      ref="organization"
      @onConfirm="getSelectNode"
      dialog
      :visible.sync="orgVisible"
      :defaultDepatment="form.department_list"
      :defaultEmployess="form.staff_list"
      isRegister="1"
    ></organization>
    <!-- 批量导入 -->
    <staff-upload ref="staffUpload" :sub-project-id="form.sub_project_id" @submit="getUploadData"></staff-upload>
    <!-- 人员详情 -->
    <staff-detail
      ref="staffDetail"
      @getListData="loadSubStaffList"
      :sub-project-id="form.sub_project_id"
      :staff-id="staffId"
      :show="true"
    ></staff-detail>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Pagination from '@/components/pagination'
import { payrollSubStaffList, payrollSubStaffDelete, payrollSubStaffAdd, syncStaffItem } from '@/api/payroll'
import searchPopup from '../../compontents/search-popup.vue'
import organization from '@/components/organization'
import staffUpload from './components/upload-dialog.vue'
import staffDetail from '../../compontents/detail'
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: { searchPopup, Pagination, organization, staffUpload, staffDetail },
  data() {
    return {
      form: {
        department_list: [],
        staff_list: [],
        sub_project_id: this.$route.params.id,
        data_type: 'all',
        search_word: '',
        page_size: 20,
        page: 1
      },
      page: {
        pageSizes: [20, 50, 100],
        total: 0
      },
      subProjectInfo: {},
      subStaffList: [],
      multipleSelection: [], // 表格选中数据
      orgVisible: false,
      updateLoa: false,
      deleteLoa: false,
      staffId: ''
    }
  },
  computed: {
    ...mapState({
      contentViewHeight: state => state.settings.contentViewHeight
    }),
    tableHeight() {
      return 500
    }
  },
  watch: {
    subStaffList: {
      handler(val) {
        this.$emit('changeList', val)
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.loadSubStaffList() // 获取员工列表
  },
  methods: {
    async loadSubStaffList(params = this.form) {
      // 获取员工列表
      const res = await payrollSubStaffList({
        ...params,
        sort: this.sort, // 排序相关
        dir: this.dir
      })
      if (res && res.code === 1) {
        this.page.total = res.data.count
        this.$set(this.activeData, 'subStaffList', res.data.list)
        this.subStaffList = res.data.list
      }
    },
    handleSizeChange(val) {
      // 每页共多少条数据
      this.form.page = 1
      this.form.page_size = val
      this.loadSubStaffList()
    },
    handleCurrentChange(val) {
      // 当前页数据
      this.form.page = val
      this.loadSubStaffList()
      this.$refs.multipleTable.clearSelection()
    },
    handleSearch() {
      // 筛选
      this.$refs.searchPopup.init()
    },
    getSearchData(data) {
      // 信息筛选
      const { department_id } = data
      data.department_name = department_id.map(item => item.department_name).join(',')
      this.form.page = 1
      this.loadSubStaffList({
        ...this.form,
        ...data
      })
    },
    batchDelete(row) {
      // 批量删除
      this.$confirm(this.$t('payroll_wage_24', { x: row ? 1 : this.multipleSelection.length }), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(() => {
          this.deleteLoa = true
          const staff_info_id = row ? [row.staff_info_id] : this.multipleSelection.map(item => item.staff_info_id)
          payrollSubStaffDelete({
            staff_ids: staff_info_id.join(','),
            sub_project_id: this.form.sub_project_id
          }).then(res => {
            this.deleteLoa = false
            const { code } = res
            if (code === 1) {
              this.$refs.multipleTable.clearSelection()
              this.loadSubStaffList()
            }
          })
        })
        .catch(() => {})
    },
    updateData() {
      // 更新数据
      this.$confirm(this.$t('payroll_wage_25'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        this.$emit('disabled', true)
        this.updateLoa = true
        syncStaffItem({ sub_project_id: this.form.sub_project_id })
          .then(res => {
            if (res && res.code === 1) {
              // 数据更新成功 提示
              let str = '<div>'
              if (res.data.update_count) str += `<p>${this.$t('payroll_salary_35', { x: res.data.update_count })}</p>`
              if (res.data.delete_count) str += `<p>${this.$t('payroll_salary_36', { x: res.data.delete_count })}</p>`
              if (!res.data.update_count && !res.data.delete_count) str = this.$t('payroll_wage_26')
              str += '</div>'
              this.$message({
                dangerouslyUseHTMLString: true,
                type: res.data.delete_count ? 'warning' : 'success',
                message: str
              })
              this.loadSubStaffList()
            }
            this.updateLoa = false
          })
          .finally(() => this.$emit('disabled', false))
      })
    },
    batchAddStaff() {
      // 批量添加成员
      this.$refs.staffUpload.init()
    },
    getUploadData() {
      // 批量导入
      this.form.page = 1
      this.$refs.multipleTable.clearSelection()
      this.loadSubStaffList()
    },
    addStaff() {
      // 添加成员
      this.orgVisible = true
      this.form.department_list = []
      this.form.staff_list = []
    },
    async getSelectNode(data) {
      // 添加成员
      if (!data.staff_list.length && !data.dept_list.length) {
        return false
      }
      const staff_ids = data.staff_list.map(item => item.staff_id).join(',')
      const department_ids = data.dept_list.map(item => item.department_id).join(',')
      this.form.department_list = data.dept_list
      this.form.staff_list = data.staff_list
      const res = await payrollSubStaffAdd({
        staff_ids,
        department_ids,
        sub_project_id: this.form.sub_project_id
      })
      if (res && res.code === 1) {
        this.form.page = 1
        this.$refs.multipleTable.clearSelection()
        this.loadSubStaffList()
      }
    },
    handleSelectionChange(val) {
      // 表格选中
      this.multipleSelection = val
    },
    handlerSort({ prop, order }) {
      this.sort = prop
      this.dir = order
      this.loadSubStaffList()
    },
    handleCheck(item) {
      // 查看
      this.staffId = item.staff_info_id
      this.$refs.staffDetail.init()
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 16px;
  color: #262626;
  margin: 0;
  padding-bottom: 16px;
}
.info {
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
  p {
    display: flex;
    flex-wrap: wrap;
    span {
      flex: 1;
      font-size: 14px;
      color: #595959;
      label {
        color: #262626;
      }
    }
  }
}
.content {
  padding-top: 24px;
  padding-bottom: 15px;
  .search {
    display: flex;
    flex-wrap: wrap;
    .search-center {
      flex: 1;
    }
    .search-left {
      padding-bottom: 16px;
      .screen {
        /deep/ span {
          display: flex;
          align-items: center;
        }
        img {
          width: 16px;
          margin-left: 4px;
        }
      }
    }
    .search-right {
      padding-bottom: 16px;
      .el-button {
        margin-left: 16px;
      }
    }
    .search-input {
      min-width: 320px;
      margin: 0 16px;
    }
  }
}
</style>
